import { render, staticRenderFns } from "./customTem.vue?vue&type=template&id=14ed0ac6"
import script from "./customTem.vue?vue&type=script&lang=js"
export * from "./customTem.vue?vue&type=script&lang=js"
import style0 from "./customTem.vue?vue&type=style&index=0&id=14ed0ac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports